import {
  CONFIRMED_GET_STOCK_TRANSACTIONS,
  STOCK_TRANSACTIONS_LOADING,
  STOCK_TRANSACTIONS_ERROR,
} from "../types/stockTransactionTypes";
import { getStockTransactionsList } from "../../services/StockTransactionService";
import { showErrorAlert } from "../../services/ErrorHandlingService";

// Format date from created_at to dd/mm/yyyy HH:mm:ss
export function formatDateWithTime(dateString) {
  if (!dateString) return "-";
  
  try {
    // Parse datetime string in format: "YYYY-MM-DD HH:mm:ss"
    const dateObj = new Date(dateString);
    
    if (isNaN(dateObj.getTime())) return "-";
    
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
   
    
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  } catch (error) {
    console.error("Date formatting error:", error);
    return "-";
  }
}

// Format transaction data from API response
export function formatStockTransactions(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((transaction) => ({
      id: transaction.id || transaction.transaction_id,
      created_at: transaction.created_at || "",
      medicine_name: transaction.medicine_name || transaction.medicine?.name || "",
      batch_no: transaction.batch_no || "",
      carton_id: transaction.carton_id || "",
      transaction_type: transaction.transaction_type || transaction.type || "",
      qty: transaction.qty || transaction.quantity || 0,
      balance_qty: transaction.balance_qty || transaction.balance_quantity || 0,
    }));
  }
  return [];
}

export function getStockTransactionsAction(
  pagination = true, 
  pageid = 0, 
  search_by = "", 
  search_keyword = "", 
  sort_by = "", 
  sort_order = "",
  branch_id = "" // ✅ Added branch_id parameter
) {
  return async (dispatch) => {
    try {
      dispatch({ type: STOCK_TRANSACTIONS_LOADING });

      // ✅ Pass branch_id to API
      const response = await getStockTransactionsList(
        pagination, 
        pageid, 
        search_by, 
        search_keyword, 
        sort_by, 
        sort_order,
        branch_id
      );
      
      if (response?.status === 200 && response?.data?.status === "success") {
        const transactions = formatStockTransactions(response.data.data);
        dispatch({
          type: CONFIRMED_GET_STOCK_TRANSACTIONS,
          payload: {
            transactions,
            num_rows: response.data.num_rows || 0
          }
        });
        return { success: true, data: transactions };
      } else {
        throw new Error(response?.data?.message || "Failed to fetch stock transactions");
      }
    } catch (error) {
      console.error("Get stock transactions error:", error);
      dispatch({ type: STOCK_TRANSACTIONS_ERROR, payload: error.message });
      showErrorAlert(error.message || "Failed to fetch stock transactions");
      throw error;
    }
  };
}
